<template>
  <div class="modal-overlay">
    <div class="modal-container modal-full-width">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>
          Chamada de Alunos - Turma: {{ turma.turma }} | {{ turma.dias }} | {{ turma.horario }} | {{ turma.instrutor }}
        </h6>
        <i class="bi bi-x-circle close-icon" @click="cancel"></i>
      </div>
      <div class="spacer"></div>

      <!-- Corpo do Modal -->
      <div class="modal-content">
        <!-- Input da Data da Aula -->
        <div class="form-group">
          <label>Data da Aula <span class="required">*</span></label>

          <div class="date-input-wrapper">
            <Flatpickr v-model="dataAula" :config="dateOptions" class="form-control input-sm-height" />
          </div>

          <!-- ✅ BÔNUS UX: limites visíveis -->
          <!-- <small class="date-hint">
            Permitido até <strong>{{ hojeFormatado }}</strong> • Somente <strong>{{ diaSemanaLabel }}</strong>
          </small> -->
          <small class="date-hint">
            Não é permitido lançar chamadas com datas futuras
          </small>
        </div>

        <!-- Tabela de Alunos Matriculados (Principal) -->
        <div v-if="alunosMatriculadosLocal.length">
          <h6 class="section-title" style="color: inherit;">Alunos Matriculados</h6>
          <table class="table table-main">
            <colgroup>
              <!-- <col style="width: 5%;"> -->
              <!-- <col style="width: 5%;"> -->
              <col style="width: 25%;">
              <col style="width: 5%;">
              <col style="width: 18%;">
              <col style="width: 12%;">
              <col style="width: 15%;">
              <col style="width: 7%;">
            </colgroup>
            <thead>
              <tr>
                <!-- <th>#</th> -->
                <!-- <th>Matrícula</th> -->
                <th>Aluno</th>
                <th style="text-align: center;">Pres</th>
                <th>Animal <span class="required">*</span></th>
                <th>Supervisão</th>
                <th>Observação</th>
                <th style="text-align: center;">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(aluno) in alunosMatriculadosLocal" :key="aluno.matricula_id">
                <!-- <td>{{ index + 1 }}</td> -->
                <!-- <td>{{ aluno.matricula_id || aluno.matricula }}</td> -->
                <td>
                  {{ aluno.aluno_nome }}
                  <span v-if="aluno.reposicao" style="color: blue;"> (Reposição)</span>
                </td>
                <td style="text-align: center;">
                  <input type="checkbox"
                        v-model="aluno.presenca" 
                        class="checkbox-sm"
                        :disabled="isAlunoDesabilitado(aluno)" />
                </td>
                <td>
                  <select v-model="aluno.animal_id" 
                    @change="onAnimalChange(aluno)"
                    class="form-control input-sm-height"
                    :disabled="isAlunoDesabilitado(aluno)">
                    <option value="" style="color: gray;">Selecione</option>
                    <option v-for="animal in animais" :key="animal.id" :value="animal.id">
                      {{ animal.nome }}
                    </option>
                  </select>
                </td>
                <td>
                  <select
                    v-model="aluno.supervisao"
                    class="form-control input-sm-height"
                    :disabled="isAlunoDesabilitado(aluno)"
                  >
                    <option value="" style="color: gray;">Selecione</option>
                    <option value="Mudar Nível">Mudar Nível</option>
                    <option value="Orientação">Orientação</option>
                  </select>
                </td>                <td>
                  <span :style="{ color: isAlunoDesabilitado(aluno) ? 'red' : 'inherit' }">
                    {{ aluno.observacoes || '' }}
                  </span>
                </td>
                <td>
                  <!-- Ícone para Registrar Queda -->
                  <i class="bi bi-person-down me-2"
                    title="Protocolo de Queda"
                    :style="{ color: aluno.animal_id ? 'red' : 'grey', cursor: aluno.animal_id ? 'pointer' : 'not-allowed' }"
                    @click="aluno.animal_id && abrirProtocoloQueda(aluno)">
                  </i>
                  <button v-if="findProtocoloQueda(aluno)" class="btn btn-link btn-sm" :disabled="isSaving" @click="abrirProtocoloQueda(aluno, true)">Nova queda</button>
                  <!-- Ícone para Registrar Ressalva -->
                  <i class="bi bi-exclamation-triangle"
                    title="Registrar Ressalva"
                    :style="{
                        color: aluno.animal_id ? 'orange' : 'grey',
                        cursor: aluno.animal_id ? 'pointer' : 'not-allowed'
                      }"
                    @click="aluno.animal_id && abrirModalRessalva(aluno)">
                  </i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Tabela de Aula Experimental -->
        <div v-if="alunosExperimentaisLocal.length">
          <h6 class="section-title" style="color: green;">Aula Experimental</h6>
          <table class="table table-extra">
            <colgroup>
              <col style="width: 5%;">
              <col style="width: 33%;">
              <col style="width: 5%;">
              <col style="width: 18%;">
              <col style="width: 25%;">
              <col style="width: 5%;">
            </colgroup>
            <thead>
              <tr>
                <th>#</th>
                <th>Aluno</th>
                <th>Pres</th>
                <th>Animal <span class="required">*</span></th>
                <th>Observações</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(aluno, index) in alunosExperimentaisLocal" :key="aluno.id">
                <td>{{ index + 1 }}</td>
                <td>
                  {{ aluno.aluno_nome }}
                  <span v-if="aluno.idade !== null && aluno.idade !== undefined" class="text-muted">
                    ({{ aluno.idade }} {{ aluno.idade === 1 ? 'ano' : 'anos' }})
                  </span>
                </td>
                <td>
                  <input type="checkbox" v-model="aluno.presenca" class="checkbox-sm" />
                </td>
                <td>
                  <select v-model="aluno.animal_id" class="form-control input-sm-height">
                    <option value="">Selecione</option>
                    <option v-for="animal in animais" :key="animal.id" :value="animal.id">
                      {{ animal.nome }}
                    </option>
                  </select>
                </td>
                <td>
                  <span>
                    {{ aluno.observacoes || '' }}
                  </span>
                </td>
                <td>
                  <i class="bi bi-person-down me-2" 
                  title="Registrar Queda" 
                  style="color: red; 
                  margin-right: 8px;" 
                  @click="aluno.animal_id && abrirProtocoloQueda(aluno)"></i>
                <button v-if="findProtocoloQueda(aluno)" class="btn btn-link btn-sm" :disabled="isSaving" @click="abrirProtocoloQueda(aluno, true)">Nova queda</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Tabela de Aula Avulsa -->
        <div v-if="alunosAvulsosLocal.length">
          <h6 class="section-title" style="color: orange;">Aula Avulsa</h6>
          <table class="table table-extra">
            <colgroup>
              <col style="width: 5%;">
              <col style="width: 33%;">
              <col style="width: 5%;">
              <col style="width: 18%;">
              <col style="width: 25%;">
              <col style="width: 5%;">
            </colgroup>
            <thead>
              <tr>
                <th>#</th>
                <th>Aluno</th>
                <th>Pres</th>
                <th>Animal <span class="required">*</span></th>
                <th>Observações</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(aluno, index) in alunosAvulsosLocal" :key="aluno.id">
                <td>{{ index + 1 }}</td>
                <td>{{ aluno.aluno_nome }}</td>
                <td>
                  <input type="checkbox" v-model="aluno.presenca" class="checkbox-sm" />
                </td>
                <td>
                  <select v-model="aluno.animal_id" class="form-control input-sm-height">
                    <option value="">Selecione</option>
                    <option v-for="animal in animais" :key="animal.id" :value="animal.id">
                      {{ animal.nome }}
                    </option>
                  </select>
                </td>
                <td>
                  <span>
                    {{ aluno.observacoes || '' }}
                  </span>
                </td>
                <td>
                  <i class="bi bi-person-down me-2" 
                  title="Registrar Queda" 
                  style="color: red; 
                  margin-right: 8px;" 
                  @click="aluno.animal_id && abrirProtocoloQueda(aluno)"></i>
                <button v-if="findProtocoloQueda(aluno)" class="btn btn-link btn-sm" :disabled="isSaving" @click="abrirProtocoloQueda(aluno, true)">Nova queda</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Tabela de Ações Registradas -->
        <div v-if="registrosPendentes.length">
          <h5 class="section-title">Ações Registradas</h5>
          <table class="table table-registered-actions">
            <colgroup>
              <col style="width: 5%;">
              <col style="width: 31%;">
              <col style="width: 14%;">
              <col style="width: 35%;">
              <col style="width: 5%;">
            </colgroup>

            <thead>
              <tr>
                <th>#</th>
                <th>Aluno</th>
                <th>Ocorrência</th>
                <th>Observações</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(acao, index) in registrosPendentes" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ acao.aluno_nome }}</td>
                <td>{{ acao.tipo_aluno }}</td>
                <td>
                  <span v-if="acao._resultadoIncerto" class="text-danger">Resultado incerto — verificar com a recepção. </span>
                  <span v-if="acao.tipo_aluno === 'Queda'">
                    {{ acao.protocolo_json?.descricao_ocorrido || acao.observacoes || '' }}
                  </span>
                  <span v-else>
                    {{ acao.observacoes || '' }}
                  </span>
                </td>
                <td>
                  <button v-if="acao.tipo_aluno === 'Queda'" class="btn btn-link btn-sm"
                    :disabled="isSaving" @click="protocoloEmEdicao = acao; showProtocoloQueda = true">Abrir protocolo</button>
                  {{ acao.tipo_aluno }}
                  <span v-if="acao.tipo_aluno === 'Queda' && acao.status" class="text-muted">
                    ({{ acao.status }})
                  </span>
                </td>
                <td style="text-align: center;">
                  <i class="bi bi-trash" 
                    style="cursor: pointer; color: red;" 
                    @click="removerAcao(index)"
                    title="Remover ação"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>


      </div>

      <!-- Rodapé (Ações) -->
      <div class="modal-footer">
        <button class="btn btn-secondary me-2" @click="cancel">Cancelar</button>
        <button 
          :class="['btn', 'me-2', isSaving ? 'btn-success' : 'btn-primary']" 
          :disabled="!formValid || isSaving"
          @click="salvarChamada"
        >
         {{ isSaving ? 'Salvando' : 'Salvar' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Novo Modal para Registrar Queda / Ressalva -->
  <div v-if="showModal" class="modal-overlay">
    <div class="modal-container" style="max-width: 500px;">
      <div class="modal-header">
        <h6>{{ modalTitle }}</h6>
        <i class="bi bi-x-circle close-icon" @click="closeModal"></i>
      </div>
      <div class="spacer"></div>
      <div class="modal-content">
        <p>Aluno: {{ modalAluno?.aluno_nome }}</p>
        <p>
          Animal: 
          {{ 
            (animais.find(a => a.id === modalAluno.animal_id)?.nome) || '—' 
          }}
       </p>

        <div class="form-group">
          <label>Descrição</label>
          <textarea v-model="modalDescricao" rows="4" class="form-control"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary me-2" @click="closeModal">Cancelar</button>
        <button class="btn btn-primary me-2" @click="salvarModal">Salvar</button>
      </div>
    </div>
  </div>

  <ConfirmManual
    v-if="showConfirmManual"
    :visible="showConfirmManual"
    :title="confirmTitle"
    :message="confirmMessage"
    cancel-text="Escolher outra data"
    confirm-text="Editar chamada"
    @confirm="handleConfirmManual"
    @cancel="handleCancelManual"
  />

  <ProtocoloQueda
    :visible="showProtocoloQueda"
    :registro="protocoloEmEdicao"
    @close="() => { showProtocoloQueda = false; protocoloEmEdicao = null; }"
    :persistir="handleSaveProtocoloQueda"
  />

</template>

<script setup>
import { ref, computed, onMounted, watch, getCurrentInstance } from 'vue';
import axios from '@/services/axios';
import Flatpickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import ConfirmManual from '@/components/ConfirmManual.vue';
import globalUtils from '@/utils/globalUtils.js';
import { criarPersistenciaQueda, snapshotProtocolo } from '@/utils/protocoloQuedaPersistencia';
import ProtocoloQueda from '@/components/modals/ProtocoloQueda.vue';


const props = defineProps({
  turma: { type: Object, required: true },

  // ✅ opcional: quando informado, o modal abre já nesta data
  dataInicial: { type: String, default: '' },
});

const emit = defineEmits(['salvou', 'cancelar']);

const isSaving = ref(false);
const persistirQueda = criarPersistenciaQueda(axios);
let envioProtocolo = null;

const dataAula = ref('');
const animais = ref([]);
const alunosMatriculadosLocal = ref([]);
const alunosExperimentaisLocal = ref([]);
const alunosAvulsosLocal = ref([]);

const registrosPendentes = ref([]);

const showProtocoloQueda = ref(false);
const protocoloEmEdicao = ref(null);

const isEditing = ref(false);
const editingChamadaId = ref(null);
// Variável temporária para armazenar os dados carregados da chamada existente
// const editingAlunos = ref({
//   matriculados: [],
//   experimentais: [],
//   avulsos: []
// });

const showConfirmManual = ref(false);
const confirmTitle = ref('Chamada já existe');
const confirmMessage = ref('Já existe chamada para essa data. Deseja editar esta chamada ou escolher outra data?');

const removerAcao = async (index) => {
  if (isSaving.value || envioProtocolo) return;
  const registro = registrosPendentes.value[index];
  if (registro._resultadoIncerto) { alert('Verifique este protocolo com a recepção antes de remover ou registrar novamente.'); return; }
  try {
    if (registro.id) await axios.delete(`/operacional/${registro.tipo_aluno === 'Queda' ? 'alunos-quedas' : 'alunos-ressalvas'}/${registro.id}`);
    registrosPendentes.value.splice(index, 1);
  } catch (error) { alert('Não foi possível remover o registro.'); }
};

function isAlunoDesabilitado(aluno) {
  if (aluno.falta_avisada_ativa === true) return true;
  if (!aluno.observacoes || aluno.observacoes.trim() === '') return false;
  const obs = aluno.observacoes.trim().toLowerCase();
  return obs.startsWith('matrícula trancada');
}

const carregarAnimais = async () => {
  try {
    const { data } = await axios.get('/cadastros/animais', {
      params: { page: 1, limit: 200, sort: 'nome', order: 'asc' }
    });

    const lista = data?.data ?? data ?? [];
    const arr = Array.isArray(lista) ? lista : [];

    // pega só ativos se o campo existir; senão mantém todos
    animais.value = arr
      .filter(a => ('ativo' in a ? (a.ativo === true || a.ativo === 1) : true))
      .sort((a, b) =>
        String(a?.nome || '').localeCompare(String(b?.nome || ''), 'pt-BR', {
          sensitivity: 'base',
          numeric: true
        })
      );
  } catch (error) {
    console.error('Erro ao carregar animais:', error);
    animais.value = [];
  }
};

const carregarAcoesRegistradas = async () => {
  try {
    const [quedasRes, ressalvasRes] = await Promise.all([
      axios.get('/operacional/alunos-quedas',    { params: { chamada_id: editingChamadaId.value } }),
      axios.get('/operacional/alunos-ressalvas', { params: { chamada_id: editingChamadaId.value } })
    ]);

    const quedas     = Array.isArray(quedasRes.data)     ? quedasRes.data     : [];
    const ressalvas = Array.isArray(ressalvasRes.data) ? ressalvasRes.data : [];

    registrosPendentes.value = [
      // QUEDAS
      ...quedas.map(r => {
        const aluno = alunosMatriculadosLocal.value.find(a => a.matricula_id === r.matricula_id);

        return {
          ...r,
          _snapshotProtocolo: snapshotProtocolo(r),
          tipo_aluno: 'Queda',
          aluno_id: aluno?.aluno_id ?? r.aluno_id ?? null,

          // compatibilidade: observacoes vira "descrição"
          observacoes: r.protocolo_json?.descricao_ocorrido || r.observacoes || r.observacao || '',

          // garantir defaults se vier vazio
          status: r.status || 'RASCUNHO',
          protocolo_json: r.protocolo_json || null,
          assinaturas_json: r.assinaturas_json || null,

          // se faltar protocolo_json (queda antiga), cria um mínimo para abrir no modal
          ...(r.protocolo_json ? {} : {
            protocolo_json: {
              versao: 1,
              aula: {
                data_aula: dataAula.value || null,
                dia_semana: props.turma?.dias || null,
                horario: props.turma?.horario || null,
                turma: props.turma?.turma ?? props.turma?.turma_id ?? null,
                instrutor_nome: props.turma?.instrutor || null,
              },
              aluno: {
                matricula_id: r.matricula_id ?? null,
                aluno_id: aluno?.aluno_id ?? r.aluno_id ?? null,
                aluno_nome: r.aluno_nome,
                animal_id: r.animal_id ?? null,
                animal_nome_snapshot: animais.value.find(a => a.id === r.animal_id)?.nome || null
              },
              checklist: {
                alerta_vermelho: { itens: [] },
                alerta_amarelo: { itens: [] },
                alerta_verde_pode_montar: { itens: [] },
                queda_nao_pode_montar: { itens: [] },
                situacoes_fora_de_aula: { itens: [] }
              },
              descricao_ocorrido: r.observacoes || r.observacao || ''
            },
            assinaturas_json: r.assinaturas_json || {
              instrutor: { assinado: false, nome: null, assinado_em: null },
              recepcao: { assinado: false, nome: null, assinado_em: null },
              supervisor: { assinado: false, nome: null, assinado_em: null },
            }
          })
        };
      }),
      // RESSALVAS
      ...ressalvas.map(r => {
        const aluno = alunosMatriculadosLocal.value
          .find(a => a.matricula_id === r.matricula_id);
        return {
          ...r,
          tipo_aluno:   'Ressalva',
          aluno_id:     aluno?.aluno_id ?? null,
          observacoes:  r.observacoes || r.observacao || ''
        };
      })
    ];
  } catch (error) {
    console.error('Erro ao carregar as ações registradas:', error);
  }
};

/**
 * Se existir um registro de Queda para este aluno em registrosPendentes,
 * atualiza o animal_id e refaz o texto de observação para refletir o novo nome do animal.
 */
 function onAnimalChange(aluno) {
  // procura o registro de queda correspondente
  const registro = registrosPendentes.value
    .find(r => r.tipo_aluno === 'Queda' && r.matricula_id === aluno.matricula_id);

  if (!registro || registro.id) {
    return; // Não altera o snapshot de uma ocorrência já persistida.
  }

  // atualiza o animal_id no registro de queda
  registro.animal_id = aluno.animal_id;

  // monta novo texto de observação, usando registro.observacoes original após o ":"
  // const animalNome = animais.value.find(a => a.id === aluno.animal_id)?.nome || '';
  const partes = registro.observacoes.split(':');
  const detalhe = partes[1] ? partes.slice(1).join(':').trim() : registro.observacoes;
  registro.observacoes = `${detalhe}`;
}


onMounted(async () => {
  await carregarAnimais();

  // ✅ prioridade 1: usar a data vinda do componente pai
  if (props.dataInicial) {
    dataAula.value = props.dataInicial;
    return;
  }

  // ✅ fallback: última data válida da turma
  const iso = ultimaDataValidaISO(allowedWeekDay);
  dataAula.value = iso;
});

const formValid = computed(() => {
  if (!dataAula.value) return false;
  
  const validAnimal = (alunos) => {
    if (alunos.length === 0) return true;
    return alunos.every(a => {
      // Se o aluno não estiver presente, não é necessário validar o animal
      if (!a.presenca) return true;
      // Se houver observações, normaliza para minúsculas e remove espaços
      const obs = a.observacoes ? a.observacoes.trim().toLowerCase() : '';
      // Aviso estruturado dispensa animal; trancamento mantém a regra legada.
      if (obs.startsWith('matrícula trancada') || a.falta_avisada_ativa === true) return true;
      // Caso contrário, o animal deve ser selecionado
      return a.animal_id && a.animal_id !== '';
    });
  };

  return (
    validAnimal(alunosMatriculadosLocal.value) &&
    validAnimal(alunosExperimentaisLocal.value) &&
    validAnimal(alunosAvulsosLocal.value)
  );
});

const instance = getCurrentInstance();

const salvarChamada = async () => {
  if (isSaving.value) return;     // protege de duplo clique
  isSaving.value = true;

  try {
    // Aguarda o envio explícito antes de processar a mesma ocorrência.
    if (envioProtocolo) await envioProtocolo;
    // 1. Monta payload da chamada
    const payloadChamada = {
      data_aula:     dataAula.value,
      data_registro: new Date().toISOString().split('T')[0],
      nome_instrutor: props.turma.instrutor,
      nivel_id:      props.turma.nivel_id,
      nivel:         props.turma.nivel,
      turma_id:      props.turma.turma,
      horario:       props.turma.horario,
      dia_semana:    props.turma.dias,
    };

    // 2. Cria ou atualiza a chamada
    let chamadaResp;
    if (isEditing.value) {
      chamadaResp = await axios.put(
        `/operacional/chamadas/${editingChamadaId.value}`,
        payloadChamada
      );
    } else {
      chamadaResp = await axios.post(
        '/operacional/chamadas',
        payloadChamada
      );
    }
    const chamadaId   = chamadaResp.data.data.id;
    editingChamadaId.value = chamadaId;
    isEditing.value = true;

    // 2) Agora busca o instrutor_id usando o endpoint /detalhes
    const detalhes = await axios.get(
      `/operacional/chamadas/detalhes`,
      {
        params: {
          data:       dataAula.value,                   // mesma data que você usou
          turma_id:   props.turma.turma,
          dia_semana: props.turma.dias,
          horario:    props.turma.horario
        }
      }
    );
    const instrutorId = detalhes.data.chamada.instrutor_id;

    // 3. Função auxiliar para envio de alunos matriculados/experimentais/avulsos
    const enviarChamadaAluno = async (aluno, tipo) => {
      const supervisao  = aluno.supervisao !== '';
      const mudarNivel  = aluno.supervisao === 'Mudar Nível';
      const payload = {
        chamada_id:      chamadaId,
        matricula_id:    aluno.matricula_id || null,
        aluno_nome:      aluno.aluno_nome,
        presenca:        aluno.presenca,
        animal_id:       aluno.animal_id || null,
        supervisao,                  // boolean conforme seleção
        observacoes:     aluno.observacoes || '',
        tipo_aluno:      tipo,
        aula_reposicao:  tipo === 'Reposição',
        aula_experimental: tipo === 'Experimental',
        aula_avulsa:     tipo === 'Avulso',
        mudar_nivel:     mudarNivel,   // boolean conforme seleção
        nome_usuario:    instance.appContext.config.globalProperties.$globalState.userName || ''
      };
      await axios.post('/operacional/chamadas-alunos', payload);
    };

    // 4. Envia alunos dos três grupos
    for (const aluno of alunosMatriculadosLocal.value) {
      const tipo = aluno.reposicao ? 'Reposição' : 'Matriculado';
      await enviarChamadaAluno(aluno, tipo);
    }
    for (const aluno of alunosExperimentaisLocal.value) {
      await enviarChamadaAluno(aluno, 'Experimental');
    }
    for (const aluno of alunosAvulsosLocal.value) {
      await enviarChamadaAluno(aluno, 'Avulso');
    }

    // 5. Cria quedas novas; quedas persistidas não são alteradas pela chamada.
    for (const registro of registrosPendentes.value) {
      const isQueda = registro.tipo_aluno === 'Queda';

      const base = isQueda
        ? '/operacional/alunos-quedas'
        : '/operacional/alunos-ressalvas';

      // Texto/descrição principal
      const descricao = isQueda
        ? (registro.protocolo_json?.descricao_ocorrido || '')
        : (registro.observacoes || '');

      // Payload para quedas/ressalvas
      const payloadRegistro = {
        chamada_id:        chamadaId,
        matricula_id:      registro.matricula_id || null,
        aluno_id:          registro.aluno_id || null,         // ✅ se seu backend/tabela aceitar
        aluno_nome:        registro.aluno_nome,
        animal_id:         registro.animal_id || null,

        // legado (mantém compatibilidade / pode ser removido depois)
        observacoes:       descricao,

        tipo_aluno:        registro.tipo_aluno,
        aula_reposicao:    registro.aula_reposicao || false,
        aula_experimental: registro.aula_experimental || false,
        aula_avulsa:       registro.aula_avulsa || false,

        // ✅ novos campos SOMENTE para Queda (se backend já estiver pronto)
        ...(isQueda ? {
          status:          registro.status || 'RASCUNHO',
          protocolo_json:  registro.protocolo_json || {},
          assinaturas_json: registro.assinaturas_json || {},
          por:             instance.appContext.config.globalProperties.$globalState.userName || ''
        } : {})
      };

      const jaPersistido = !!registro.id;
      if (isQueda) await persistirQueda(registro, payloadRegistro);
      else if (jaPersistido) await axios.put(`${base}/${registro.id}`, payloadRegistro);
      else {
        const resposta = await axios.post(base, payloadRegistro);
        registro.id = resposta.data?.data?.id || resposta.data?.id;
      }

      // Log em observações do aluno (continua como você já faz)
      const animalNome =
        animais.value.find(a => a.id === registro.animal_id)?.nome
        || registro.protocolo_json?.aluno?.animal_nome_snapshot
        || '';

      const textoObs = isQueda
        ? `Queda - ${animalNome}: ${descricao}`
        : `${registro.tipo_aluno}: ${descricao}`;

      const payloadObs = {
        aluno_id: registro.aluno_id || null,
        chamada_id:      chamadaId,
        matricula_id:    registro.matricula_id || null,
        observacao:      textoObs,
        falta_avisada:   false,
        data_falta:      isQueda ? new Date().toISOString().split('T')[0] : null,
        nome_usuario:    instance.appContext.config.globalProperties.$globalState.userName || '',
        data_observacao: dataAula.value
      };

      const podeGravarObs = !!registro.aluno_id && !!(registro.matricula_id);

      if (podeGravarObs && (!jaPersistido || registro._observacaoPendente)) {
        await axios.post('/operacional/alunos-observacoes', payloadObs);
        registro._observacaoPendente = false;
      } else {
        console.warn('[Chamada] Observação NÃO gravada em alunos_observacoes (exige aluno_id + matricula_id):', {
          aluno_nome: registro.aluno_nome,
          tipo: registro.tipo_aluno,
          aluno_id: registro.aluno_id ?? null,
          matricula_id: registro.matricula_id ?? null,
          chamadaId
        });
      }
    }

  // 7. Grava em lote as solicitações de supervisão (DELETE + INSERT via POST em array)
  const hoje = new Date().toISOString().split('T')[0];

  // Monta o array só com quem tem supervisão marcada
  const supervisoes = alunosMatriculadosLocal.value
    .filter(a => a.supervisao !== '')
    .map(a => ({
      chamada_id:       chamadaId,
      aluno_id:         a.aluno_id,
      instrutor_id:     instrutorId,
      turma_id:         props.turma.turma,
      nivel_id:         props.turma.nivel_id,
      mudar_nivel:      a.supervisao === 'Mudar Nível',
      data_solicitacao: hoje,
      data_realizacao:  null,
      realizada:        false,
      nota_avaliacao:   null,
      aprovado:         false
    }));

  await axios.post('/operacional/alunos-supervisoes', { chamada_id: chamadaId, supervisoes });

    // 8. Mantém as identidades até o pai fechar o modal e confirma o salvamento
    emit('salvou', { chamadaId });
  } catch (error) {
    console.error('Erro ao salvar a chamada:', error);
    alert(error.message || 'Erro ao salvar a chamada. Os dados foram mantidos.');
  } finally {
     isSaving.value = false;
  }
};

// CONTROLE DO MODAL PARA QUEDA/RESSALVA
const showModal = ref(false);
const modalTitle = ref('');
const modalAluno = ref(null);
const modalDescricao = ref('');

function findProtocoloQueda(aluno) {
  return registrosPendentes.value.find(r =>
    r.tipo_aluno === 'Queda' &&
    (r.matricula_id ? r.matricula_id === aluno.matricula_id : r.aluno_nome === aluno.aluno_nome)
  );
}

async function abrirProtocoloQueda(aluno, novaOcorrencia = false) {
  if (isSaving.value || envioProtocolo) return;
  if (!aluno?.animal_id) return;

  // ✅ garante chamada_id antes de abrir o protocolo (para o snapshot do responsável funcionar)
  const chamadaId = editingChamadaId.value || await garantirChamadaCabecalho();

  const existente = novaOcorrencia ? null : findProtocoloQueda(aluno);
  if (existente) {
    // garante chamada_id no existente também
    if (!existente.chamada_id) existente.chamada_id = chamadaId;

    protocoloEmEdicao.value = existente;
    showProtocoloQueda.value = true;
    return;
  }

  const animalId = aluno.animal_id || null;
  const matriculaId = aluno.matricula_id || null;

  const aula_reposicao = aluno.tipo_aluno === 'Reposição' || aluno.reposicao === true;
  const aula_experimental = aluno.tipo_aluno === 'Experimental';
  const aula_avulsa = aluno.tipo_aluno === 'Avulso';

  const novo = {
    _tmpId: `tmp_${Date.now()}_${Math.random().toString(16).slice(2)}`,
    tipo_aluno: 'Queda',

    // ✅ agora sempre vem preenchido
    chamada_id: chamadaId,

    matricula_id: matriculaId,
    aluno_id: aluno.aluno_id ?? null,
    aluno_nome: aluno.aluno_nome,
    animal_id: animalId,

    aula_reposicao,
    aula_experimental,
    aula_avulsa,

    status: 'RASCUNHO',
    protocolo_json: {
      versao: 1,
      aula: {
        data_aula: dataAula.value || null,
        dia_semana: props.turma.dias || null,
        horario: props.turma.horario || null,
        turma: props.turma.turma || props.turma.turma_id || null,
        instrutor_nome: props.turma.instrutor || null,
      },
      aluno: {
        matricula_id: matriculaId,
        aluno_id: aluno.aluno_id ?? null,
        aluno_nome: aluno.aluno_nome,
        animal_id: animalId,
        animal_nome_snapshot: (animais.value.find(a => a.id === animalId)?.nome) || null,

        // (opcional) já cria os campos para o snapshot do responsável
        responsavel_nome_snapshot: null,
        responsavel_celular_snapshot: null,
      },
      checklist: {
        alerta_vermelho: { itens: [] },
        alerta_amarelo: { itens: [] },
        alerta_verde_pode_montar: { itens: [] },
        queda_nao_pode_montar: { itens: [] },
        situacoes_fora_de_aula: { itens: [] }
      },
      descricao_ocorrido: ''
    },
    assinaturas_json: {
      instrutor: { assinado: false, nome: null, assinado_em: null },
      recepcao: { assinado: false, nome: null, assinado_em: null },
      supervisor: { assinado: false, nome: null, assinado_em: null },
    }
  };

  protocoloEmEdicao.value = novo;
  showProtocoloQueda.value = true;
}

function handleSaveProtocoloQueda(updated, expected) {
  if (envioProtocolo) return envioProtocolo;
  if (isSaving.value) return Promise.reject(new Error('Aguarde o salvamento da chamada e envie o protocolo novamente.'));
  // Mantém uma referência canônica por ocorrência, sem agrupar por aluno/data.
  let registro = registrosPendentes.value.find(r =>
    (updated._tmpId && r._tmpId === updated._tmpId) || (updated.id && r.id === updated.id)
  );
  if (!registro) {
    registrosPendentes.value.push(updated);
    registro = registrosPendentes.value[registrosPendentes.value.length - 1];
  } else {
    Object.assign(registro, updated);
  }
  envioProtocolo = (async () => {
    const payload = {
      ...updated,
      chamada_id: updated.chamada_id || editingChamadaId.value,
      observacoes: updated.protocolo_json?.descricao_ocorrido || '',
      descricao: updated.protocolo_json?.descricao_ocorrido || '',
      por: instance.appContext.config.globalProperties.$globalState.userName || ''
    };
    const alterado = registro.id && expected &&
      JSON.stringify(snapshotProtocolo(updated)) !== JSON.stringify(expected);
    const salvo = await persistirQueda(registro, payload, alterado ? expected : null);
    protocoloEmEdicao.value = salvo;
    showProtocoloQueda.value = false;
    return salvo;
  })().catch(error => {
    if (expected) {
      registro.status = expected.status;
      registro.assinaturas_json = JSON.parse(JSON.stringify(expected.assinaturas_json));
    }
    throw error;
  }).finally(() => { envioProtocolo = null; });
  return envioProtocolo;
}

const abrirModalRessalva = (aluno) => {
  modalAluno.value = aluno;
  modalTitle.value = 'Registrar Ressalva';
  modalDescricao.value = '';
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
};

const salvarModal = async () => {
  try {
    // Converte campos vazios para null conforme necessário.
    const animalId = modalAluno.value.animal_id === "" || modalAluno.value.animal_id === undefined
                      ? null : modalAluno.value.animal_id;
    const matriculaId = modalAluno.value.matricula_id === "" || modalAluno.value.matricula_id === undefined
                         ? null : modalAluno.value.matricula_id;

    // Define os booleanos de acordo com o tipo do aluno
    const aula_reposicao = modalAluno.value.tipo_aluno === 'Reposição';
    const aula_experimental = modalAluno.value.tipo_aluno === 'Experimental';
    const aula_avulsa = modalAluno.value.tipo_aluno === 'Avulso';

    // Monta o payload com os dados coletados no modal:
    const novoRegistro = {
      // O campo chamada_id ficará para ser preenchido depois de salvar a chamada principal.
      chamada_id: null,
      matricula_id: matriculaId,
      aluno_id: modalAluno.value.aluno_id,
      aluno_nome: modalAluno.value.aluno_nome,
      animal_id: animalId,
      observacoes: modalDescricao.value,
      // Define o tipo com base no título do modal (queda ou ressalva)
      tipo_aluno: modalTitle.value === 'Registrar Queda' ? 'Queda' : 'Ressalva',
      aula_reposicao,
      aula_experimental,
      aula_avulsa
    };

    // Adiciona o novo registro no array de registros pendentes
    registrosPendentes.value.push(novoRegistro);
    closeModal();
  } catch (error) {
    console.error('Erro ao preparar registro:', error);
    alert("Erro ao preparar o registro. Verifique os logs para mais detalhes.");
  }
};


async function handleConfirmManual() {
  // Marca que estamos em edição e fecha o diálogo
  isEditing.value = true;
  showConfirmManual.value = false;

  // Carrega quedas/ressalvas (registros pendentes)
  await carregarAcoesRegistradas();
}

function handleCancelManual() {
  // Em vez de fechar o modal, apenas fecha o confirm e permite escolher outra data
  showConfirmManual.value = false;

  // Volta para modo novo (sem edição) e limpa os dados carregados da chamada existente
  isEditing.value = false;
  editingChamadaId.value = null;

  alunosMatriculadosLocal.value = [];
  alunosExperimentaisLocal.value = [];
  alunosAvulsosLocal.value = [];
  registrosPendentes.value = [];

  // Mantém dataAula como está para o usuário trocar no calendário
  // (se preferir, pode limpar: dataAula.value = '' ; mas NÃO chame cancel())
}

async function loadDadosChamada(formattedDate) {
  // helper LOCAL → não gera aviso do eslint
  const appendObs = (base, extra) => {
    const b = String(base || '').trim();
    const e = String(extra || '').trim();
    if (!e) return b;
    if (!b) return e;
    // evita "texto - texto" quando o base já é o extra
    if (b === e || b.includes(e)) return b;
    return `${b} - ${e}`;
  };

  const turmaId = props.turma.turma_id   // Dashboard
               ?? props.turma.turma      // ListarTurmasInstrutor
               ?? props.turma.nivel_id
               ?? props.turma.dias_horarios_id;

  if (!turmaId) {
    console.error("loadDadosChamada: sem turma_id em props.turma", props.turma);
    return;
  }

  const params = {
    data:       formattedDate,
    turma_id:   turmaId,
    dia_semana: props.turma.dias,
    horario:    props.turma.horario
  };

  try {
    const { data } = await axios.get(`/operacional/turmas-instrutor/modal`, { params });

    // =========================
    // Matriculados + Reposição
    // =========================
    alunosMatriculadosLocal.value = [
      ...(data.matriculados || []).map(a => {
        const base = a.observacao || a.observacoes || "";
        return {
          ...a,
          reposicao:    false,
          presenca:     a.falta_avisada_ativa !== true,
          supervisao:   "",
          mudar_nivel:  false,
          animal_id:    a.animal_id || "",
          // mantém texto atual e, se houver extra (prospeccao.observacoes), apenda
          observacoes:  appendObs(base, a.observacoes),
        };
      }),
      ...(data.reposicao || []).map(a => {
        const base = a.observacao || a.observacoes || "";
        return {
          ...a,
          reposicao:    true,
          presenca:     true,
          supervisao:   "",
          mudar_nivel:  false,
          animal_id:    a.animal_id || "",
          observacoes:  appendObs(base, a.observacoes),
        };
      })
    ];

    // =========================
    // Experimentais (somente do dia)
    // =========================
    const expsDoDia = (data.experimentais || [])
      .filter(a => String(a.data_aula).slice(0, 10) === formattedDate)
      .map(a => {
        const textoBase = a.status
          ? `${a.status === 'Confirmada' ? 'Confirmada' : a.status} para o dia ${globalUtils.formatarData(a.data_aula)}`
          : (a.observacao || a.observacoes || "");

        return {
          ...a,
          tipo_aluno: 'Experimental',
          presenca:    true,
          supervisao:  "",
          mudar_nivel: false,
          animal_id:   a.animal_id || "",
          // ✅ NOVO: apenda prospeccao.observacoes quando existir
          observacoes: appendObs(textoBase, a.observacoes),
        };
      });

    alunosExperimentaisLocal.value = expsDoDia;

    // =========================
    // Avulsas (somente do dia + dedup por aluno_id)
    // =========================
    const avulsosDoDia = (data.avulsos || [])
      .filter(a => String(a.data_aula).slice(0, 10) === formattedDate);

    const seen = new Set();
    const avulsosUnicos = [];
    for (const a of avulsosDoDia) {
      const key = a.aluno_id ?? a.id; // fallback defensivo
      if (seen.has(key)) continue;
      seen.add(key);
      avulsosUnicos.push(a);
    }

    alunosAvulsosLocal.value = avulsosUnicos.map(a => {
      const base = a.observacao || a.observacoes || "";
      return {
        ...a,
        tipo_aluno: 'Avulso',
        presenca:     true,
        supervisao:   "",
        mudar_nivel:  false,
        animal_id:    a.animal_id || "",
        // ✅ NOVO: apenda prospeccao.observacoes quando existir
        observacoes:  appendObs(base, a.observacoes),
      };
    });

  } catch (err) {
    console.error("Erro em loadDadosChamada:", err);
  }
}

async function garantirChamadaCabecalho() {
  const payloadChamada = {
    data_aula:      dataAula.value,
    data_registro:  new Date().toISOString().split('T')[0],
    nome_instrutor: props.turma.instrutor,
    nivel_id:       props.turma.nivel_id,
    nivel:          props.turma.nivel,
    turma_id:       props.turma.turma,
    horario:        props.turma.horario,
    dia_semana:     props.turma.dias,
  };

  // Se já estamos editando, só garante o PUT
  if (isEditing.value && editingChamadaId.value) {
    const r = await axios.put(`/operacional/chamadas/${editingChamadaId.value}`, payloadChamada);
    return r.data.data.id;
  }

  // Senão, cria (rascunho de cabeçalho)
  const r = await axios.post('/operacional/chamadas', payloadChamada);

  const newId = r.data.data.id;
  isEditing.value = true;
  editingChamadaId.value = newId;

  return newId;
}


// Watch que dispara ao escolher a data na UI
watch(dataAula, async (newDate) => {

  if (!newDate) return;

  const selected = new Date(newDate);
  selected.setHours(0,0,0,0);

  const today = new Date();
  today.setHours(0,0,0,0);

  if (selected > today) {
    alert('Não é permitido lançar chamada com data futura.');
    dataAula.value = ''; // ou seta pra hoje (ver abaixo)
    return;
  }

  const formattedDate = new Date(newDate).toISOString().split("T")[0];
  const turmaId = props.turma.turma_id   // do Dashboard
               ?? props.turma.turma      // do ListarTurmasInstrutor
               ?? props.turma.nivel_id
               ?? props.turma.dias_horarios_id;
  if (!turmaId) {
    console.error("watch(dataAula): props.turma sem ID válido", props.turma);
    return;
  }

  const checkParams = {
    data:       formattedDate,
    turma_id:   turmaId,
    dia_semana: props.turma.dias,
    horario:    props.turma.horario
  };

  try {
    // 1) tenta buscar chamada já existente
    const { data: checkData } = await axios.get(
      `/operacional/chamadas/detalhes`,
      { params: checkParams }
    );

    if (checkData.chamada) {
      isEditing.value = true;
      editingChamadaId.value = checkData.chamada.id;

      const todos = Array.isArray(checkData.alunos) ? checkData.alunos : [];

      // ✅ Caso especial: existe chamada (cabeçalho), mas ainda não existem chamadas-alunos
      if (todos.length === 0) {
        // carrega alunos da turma (como modo novo)
        await loadDadosChamada(formattedDate);

        // agora sim carrega ações registradas (quedas/ressalvas) da chamada
        await carregarAcoesRegistradas();

        // não precisa pedir confirmação, porque não tem “dados preenchidos” para conflitar
        showConfirmManual.value = false;
        return;
      }

      // ✅ Caso normal: chamada existente com alunos já gravados
      alunosMatriculadosLocal.value = todos
        .filter(a => a.tipo_aluno === "Matriculado" || a.tipo_aluno === "Reposição")
        .map(a => ({
          ...a,
          presenca:   a.presenca ?? true,
          supervisao: a.supervisao
            ? (a.mudar_nivel ? "Mudar Nível" : "Orientação")
            : "",
          reposicao: a.tipo_aluno === "Reposição"
        }));

      alunosExperimentaisLocal.value = todos
        .filter(a => a.tipo_aluno === "Experimental")
        .map(a => ({ ...a, presenca: a.presenca ?? true }));

      alunosAvulsosLocal.value = todos
        .filter(a => a.tipo_aluno === "Avulso")
        .map(a => ({ ...a, presenca: a.presenca ?? true }));

      // pede confirmação antes de editar (continua igual)
      showConfirmManual.value = true;
      confirmMessage.value = "Já existe chamada para essa data. Deseja editar esta chamada ou escolher outra data?";
      return;
    }

  } catch (err) {
    // Se cair aqui, não havia chamada — vai para modo novo
    console.warn("Nenhuma chamada existente ou erro 400, vou carregar turma:", err);
  }

  // 2) MODO NOVO: busca só os alunos da turma
  isEditing.value = false;
  editingChamadaId.value = null;
  await loadDadosChamada(formattedDate);
});


function convertDiaSemana(dia) {
  const dias = {
    'domingo': 0,
    'segunda-feira': 1,
    'terça-feira': 2,
    'quarta-feira': 3,
    'quinta-feira': 4,
    'sexta-feira': 5,
    'sábado': 6
  };
  return dias[dia.toLowerCase()] ?? null;
}

const allowedWeekDay = convertDiaSemana(props.turma.dias) || 0;

function ultimaDataValidaISO(weekday) {
  // weekday: 0..6
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const d = new Date(today);

  // recua até bater o weekday desejado (inclui hoje se hoje já for o dia correto)
  while (d.getDay() !== weekday) {
    d.setDate(d.getDate() - 1);
  }

  // retorna YYYY-MM-DD
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

// const DIA_LABEL = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];

// const diaSemanaLabel = computed(() => DIA_LABEL[allowedWeekDay] || '—');

// const hojeFormatado = computed(() => {
//   const t = new Date();
//   t.setHours(0,0,0,0);
//   return t.toLocaleDateString('pt-BR');
// });

const dateOptions = {
  dateFormat: "Y-m-d",
  altInput: true,
  altFormat: "d/m/Y",
  locale: Portuguese,
  enable: [
    function(date) {
      // 1) só o dia da semana da turma
      if (date.getDay() !== allowedWeekDay) return false;

      // 2) não permitir futuro (comparando por dia, sem hora)
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const d = new Date(date);
      d.setHours(0, 0, 0, 0);

      return d <= today;
    }
  ]
};

const cancel = () => {
  if (isSaving.value || envioProtocolo) return;
  registrosPendentes.value = [];
  emit('cancelar');
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  display: flex;
  flex-direction: column;   /* empilha header, conteúdo e footer */
  background: #fff;
  width: 100%;
  max-width: 800px;
  max-height: 90%;         /* limita a altura total do modal */
  overflow: hidden;        /* esconde o rolagem fora do container */
  margin: 0 auto;
  border-radius: 0px;
}

.modal-header {
  background: #ccc;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}

.spacer {
  margin-bottom: 20px;
}

.modal-content {
  padding: 10px 15px;
  flex: 1;                 /* ocupa todo espaço disponível entre header e footer */
  overflow-y: auto;        /* habilita a rolagem só aqui */
}

.modal-footer {
  flex-shrink: 0;          /* mantém sempre a mesma altura */
  display: flex;
  justify-content: flex-end;
  padding: 15px;
}

/* .section-title {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.form-group {
  margin-bottom: 15px;
} */

.form-control {
  width: 100%;
  padding: 5px;
  border: 1px solid #ced4da;
  border-radius: 0px;
}

.date-input-wrapper {
  width: 300px;
}

.date-input-wrapper .form-control {
  width: 100%;
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;
}

.table th, .table td {
  border: 1px solid #ddd;
  padding: 8px;
  vertical-align: middle;
}


.flatpickr-calendar {
  font-family: 'Roboto', sans-serif;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.flatpickr-day.selected {
  background-color: #1976d2;
  color: white;
}

.flatpickr-day:hover {
  background-color: #e0e0e0;
}

.checkbox-sm {
  width: 14px;
  height: 14px;
}

.acoes-registradas {
  margin-top: 15px;
  margin-bottom: 15px;
}

.table-registered-actions {
  width: 100%;
  border-collapse: collapse;
}

.table-registered-actions th,
.table-registered-actions td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.date-hint {
  display: inline-block;
  margin-top: 6px;
  color: #6c757d;          /* cinza Bootstrap */
  font-size: 12px;
}
</style>
